// iOS Safari ignores preload="metadata" and paints nothing before playback,
// so a video without a poster shows as a black box. A media fragment start
// time (#t=0.1) makes it fetch and paint the frame at 0.1s instead. Applied
// at render time only — stored article HTML is never changed — and only to
// videos without a poster (the poster already gives them a picture).
const FRAME_HINT = '#t=0.1';

export const withFrameHint = (src) => {
    if (typeof src !== 'string') {
        return src;
    }
    const trimmed = src.trim();
    if (!trimmed || trimmed.includes('#') || /^(?:data|blob):/i.test(trimmed)) {
        return src;
    }
    return `${src}${FRAME_HINT}`;
};

const VIDEO_TAG_PATTERN = /<video\b(?:[^>"']|"[^"]*"|'[^']*')*>/gi;
const POSTER_ATTRIBUTE = /\sposter\s*=/i;
const SRC_ATTRIBUTE = /(\ssrc=)("([^"]*)"|'([^']*)')/i;

/**
 * Rewrites the HTML before it is injected (site ArticlePage, legacy
 * PostDetail), so the browser never starts loading the un-hinted src.
 * Editor output always carries src on the <video> itself.
 */
export const addVideoFrameHints = (html) => {
    if (typeof html !== 'string' || !/<video\b/i.test(html)) {
        return html;
    }
    return html.replace(VIDEO_TAG_PATTERN, (tag) => {
        if (POSTER_ATTRIBUTE.test(tag)) {
            return tag;
        }
        return tag.replace(SRC_ATTRIBUTE, (match, prefix, quoted, doubleQuoted, singleQuoted) => {
            const src = doubleQuoted !== undefined ? doubleQuoted : singleQuoted;
            const quote = quoted.charAt(0);
            return `${prefix}${quote}${withFrameHint(src)}${quote}`;
        });
    });
};
